module.exports = __webpack_public_path__ + "media/icons/web-banking-gray-1cee2c33.png";